/**
 * Reemplaza variables de plantilla con datos del lead.
 * Variables soportadas: {nombre}, {curso}, {negocio}, {telefono}, {edad}, {precio}
 */
export function aplicarVariables(mensaje, lead, config) {
  if (!mensaje) return "";
  const producto = config?.productos?.find(p =>
    p.nombre?.toLowerCase() === lead?.cursoInteres?.toLowerCase()
  );
  return mensaje
    .replace(/\{nombre\}/gi, lead?.nombre || "")
    .replace(/\{curso\}/gi, lead?.cursoInteres || "")
    .replace(/\{negocio\}/gi, config?.nombreNegocio || "")
    .replace(/\{telefono\}/gi, lead?.telefono || "")
    .replace(/\{edad\}/gi, lead?.edad || "")
    .replace(/\{precio\}/gi, producto ? `${config.moneda} ${producto.precio}` : "");
}

let whatsappWindow = null;
export function abrirWhatsApp(telefono, mensaje = "") {
  const movil = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
  const numero = String(telefono).replace(/\D/g, "");
  if (!numero) return false;
  const url = movil
    ? `https://wa.me/${numero}?text=${encodeURIComponent(mensaje)}`
    : `https://web.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(mensaje)}`;
  try {
    if (whatsappWindow && !whatsappWindow.closed) {
      whatsappWindow.location.href = url;
      whatsappWindow.focus();
      return true;
    }
  } catch { whatsappWindow = null; }
  // noopener/noreferrer force a new context instead of reusing the named tab.
  whatsappWindow = window.open("", "corebase-whatsapp");
  if (!whatsappWindow) return false;
  try { whatsappWindow.opener = null; } catch { /* cross-origin tab */ }
  whatsappWindow.location.href = url;
  whatsappWindow.focus();
  return true;
}

/**
 * Limpia el teléfono para wa.me: quita espacios, guiones, paréntesis.
 * Usa el código de país del lead, o el por defecto del negocio.
 */
export function limpiarTelefono(telefono, codigoPaisLead, codigoPaisConfig) {
  if (!telefono) return "";
  const codigo = codigoPaisLead || codigoPaisConfig || "591";
  let limpio = telefono.replace(/[\s\-\(\)\.]/g, "");
  if (limpio.startsWith("0")) limpio = codigo + limpio.slice(1);
  if (limpio.startsWith("+")) limpio = limpio.slice(1);
  if (!/^\d{1,4}/.test(limpio) || limpio.length <= 8) limpio = codigo + limpio;
  return limpio;
}
